
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';



const Notifications = () => {
    const navigate = useNavigate();
    const [currentNotifications, setCurrentNotifications] = useState(null);
    const [earlierNotifications, setEarlierNotifications] = useState(null);

    useEffect(() => {

        getCurrentNotifications();
        getEarlierNotifications();
        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }

    }, []);


    useEffect(() => {

        return () => {
            markRead();
        };

    }, [currentNotifications]);

    const getCurrentNotifications = async () => {

        axios.get(process.env.REACT_APP_API_URL + "/get-current-notifications", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setCurrentNotifications(response?.data?.current_notifications);




                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }




    const getEarlierNotifications = async () => {

        axios.get(process.env.REACT_APP_API_URL + "/get-earlier-notifications", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setEarlierNotifications(response?.data?.earlier_notifications);



                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }
    const removeNotification = async (notification_id, is_current) => {


        await axios.post(process.env.REACT_APP_API_URL + "/remove-notification", {
            notification_id: notification_id,
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    if (is_current == 1) {

                        const tmp = currentNotifications.filter(function (n) {
                            return n.notification_id !== notification_id
                        })
                        setCurrentNotifications(tmp);

                    }
                    else {

                        const tmp = earlierNotifications.filter(function (n) {
                            return n.notification_id !== notification_id
                        })
                        setEarlierNotifications(tmp)

                    }



                } else {

                    Swal.fire({ icon: "error", title: "Delete Notification Failed", text: response?.data?.message });

                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });

    };

    const markRead = () => {


        if (currentNotifications) {
            const notification_ids = currentNotifications.map(n => n.notification_id);


            axios.post(process.env.REACT_APP_API_URL + "/mark-notifications-read", {
                notification_ids: notification_ids,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {



                })
                .catch(function (error) {

                    Swal.fire({ icon: "error", title: "Notification Processing Failed", text: error.message });

                });

        }
    }
    const backToProfile = async (e) => {

        navigate("/profile");


    };

    return (


        <>



            <div className="title-box">

                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToProfile} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Notifications</h3>
                <div className="flex-equal justify-content-end" ></div>

            </div>


            <div className="box" >


                <div className="fs-11 color-green">NEW</div>

                {currentNotifications?.length>0 ? currentNotifications.map((n, index) => {
                    return <div className="card " >

                    <div className="card-title" >

                        <label className="color-white fs-18" >{n.notification_title}</label>

                    </div>
                    <div className="card-content fd-row  align-items-center" >

                        <label className="color-light fs-14 flex-grow-1">{n.notification_description}</label>

                        <span className="p-8" onClick={() => { removeNotification(n.notification_id, 0) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M11.4731 9.99944L15.4505 13.9769L13.9774 15.4501L9.99993 11.4726L6.02246 15.4501L4.54932 13.9769L8.52679 9.99944L4.54932 6.02197L6.02246 4.54883L9.99993 8.5263L13.9774 4.54883L15.4505 6.02197L11.4731 9.99944Z" fill="white" />
                            </svg>
                        </span>

                    </div>

                </div>        
                        })

               :
                    <div className="card" >

                        <div className="card-content p-32 fs-14" >
                            <label className="color-light fs-16 ">No New Notifications</label>

                        </div>

                    </div>
                }
            </div>




            <div className="box" >

                <div className="fs-11 color-light">EARLIER</div>


                {earlierNotifications?.length>0 ? earlierNotifications.map((n, index) => {
                    return <div className="card " >

                        <div className="card-title" >

                            <label className="color-white fs-18" >{n.notification_title}</label>

                        </div>
                        <div className="card-content fd-row" >

                            <label className="color-light fs-14 flex-grow-1">{n.notification_description}</label>

                            <span className="p-8" onClick={() => { removeNotification(n.notification_id, 0) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M11.4731 9.99944L15.4505 13.9769L13.9774 15.4501L9.99993 11.4726L6.02246 15.4501L4.54932 13.9769L8.52679 9.99944L4.54932 6.02197L6.02246 4.54883L9.99993 8.5263L13.9774 4.54883L15.4505 6.02197L11.4731 9.99944Z" fill="white" />
                                </svg>
                            </span>

                        </div>

                    </div>
                })
:
                   <div className="card" >

                        <div className="card-content p-32 fs-14" >
                            <label className="color-light fs-16 ">No Earlier Notifications</label>

                        </div>

                    </div>
                }

            </div>

        </>


    );
};

export default Notifications;